//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { goTo } from '@changba/funny';
import { props } from './props';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "cb-header"
  }, [_c('div', {
    staticClass: "btn-rule-container",
    on: {
      "click": function ($event) {
        return _vm.$emit('rule');
      }
    }
  }, [_vm._t("rule", function () {
    return [_c('button', {
      staticClass: "btn-rule"
    }, [_vm._v("活动规则")])];
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "btn-exchange-container",
    on: {
      "click": _vm.goto
    }
  }, [_vm._t("exchange", function () {
    return [_c('button', {
      staticClass: "btn-exchange"
    }, [_vm._v("兑换中心")])];
  })], 2), _vm._v(" "), _vm._t("default")], 2);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-5aaa1b19',
  render,
  name: 'CbHeader',
  props,
  methods: {
    goto() {
      this.type === 'baofang' ? goTo.baofangMall() : goTo.luboMall();
    }
  }
});